import { Dispatch, SetStateAction } from 'react';
import TextField from '@mui/material/TextField';
import CloseIcon from '@mui/icons-material/Close';
import { Modal, Button, } from '@mui/material'

interface CommissionOfferModalProps {
    open: boolean;
    onClose: () => void;
    setOpen: Dispatch<SetStateAction<boolean>>
}

export default function CommissionOfferModal({ open, onClose, setOpen }: CommissionOfferModalProps) {
    return (
        <Modal
            className="modal commissionOffer_modal"
            open={open}
            onClose={onClose}
        >
            <div className="modal-dialog">
                <div className="modal-body">
                    <div className="modal_title">
                        <h2>Add Commission</h2>
                        <div
                            role="button"
                            tabIndex={0}
                            className="btn-close"
                            onClick={() => setOpen(false)}
                        >
                            <CloseIcon />
                        </div>
                    </div>
                    <div className="view_page gap_p">
                        <div className="w_100">
                            <h6>Quoted Price</h6>
                            <p className="c_primary">AED 200</p>
                        </div>
                    </div>
                    <form className="form" action="">
                        <div className="control_group">
                            <div className="section_title">
                                <h2>Commission</h2>
                            </div>
                            <TextField placeholder="Enter Commission" fullWidth hiddenLabel></TextField>
                        </div>
                        <div className="footer_btn_flex">
                            <Button className="btn btn_grey" onClick={() => setOpen(false)}>Cancel</Button>
                            <Button className="btn btn_primary" onClick={() => setOpen(false)}>Submit</Button>
                        </div>
                    </form>
                </div>
            </div>
        </Modal >
    )
}
